export default __webpack_public_path__ + "static/media/clockIcon.e929976b.svg";